const CUISINE_TYPES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default CUISINE_TYPES_INITIAL_STATE
